module.exports.trapper = {
  ru: {
    title: 'Ловец в Авалоне: правила дополнения',
    description:
      'Правила Ловца в Авалоне для 8–10 игроков: лишний участник похода, исключение карты после Экскалибура, тайная информация лидера и примеры подсчёта.',
    keywords: ['Ловец в Авалоне: правила дополнения'],
  },
  en: {
    title: 'Trapper in Avalon: expansion rules',
    description:
      'Avalon Trapper rules for 8–10 players: an extra mission participant, excluding a card after Excalibur, private leader information and counting examples.',
    keywords: ['Trapper in Avalon: expansion rules'],
  },
  es: {
    title: 'Trampero en Avalon: reglas de la expansión',
    description:
      'Reglas del Trampero para 8–10 jugadores: un participante extra, excluir una carta tras Excalibur, información del líder y ejemplos de recuento.',
    keywords: ['Trampero en Avalon: reglas de la expansión'],
  },
  pt: {
    title: 'Armadilheiro em Avalon: regras da expansão',
    description:
      'Regras do Armadilheiro para 8–10 jogadores: participante extra, exclusão após Excalibur, informação privada do líder e exemplos de contagem.',
    keywords: ['Armadilheiro em Avalon: regras da expansão'],
  },
  vi: {
    title: 'Người đặt bẫy trong Avalon: luật bản mở rộng',
    description:
      'Luật Người đặt bẫy cho 8–10 người: thêm thành viên nhiệm vụ, loại bài sau Excalibur, thông tin riêng của đội trưởng và ví dụ tính kết quả.',
    keywords: ['Người đặt bẫy trong Avalon: luật bản mở rộng'],
  },
  'zh-CN': {
    title: '阿瓦隆捕手：扩展规则',
    description:
      '阿瓦隆捕手8–10人规则：任务多派一人，王者之剑后排除任务牌，队长私下查看牌面。含计数示例及与剧情牌的兼容限制。',
    keywords: ['阿瓦隆捕手：扩展规则'],
  },
  'zh-TW': {
    title: '阿瓦隆捕手：擴充規則',
    description:
      '阿瓦隆捕手8–10人規則：任務多派一人，王者之劍後排除任務牌，隊長私下查看牌面。含計數範例及與劇情牌的相容限制。',
    keywords: ['阿瓦隆捕手：擴充規則'],
  },
};
